import React from "react";

const Soc2 = () => {
    return (
        <>

            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb16">

                <div className="bg-breadcrumb-single" />

                <div
                    className="container text-center py-5"
                    style={{ maxWidth: 900 }}
                >

                    <h4
                        className="text-white display-4 mb-4 wow fadeInDown"
                        data-wow-delay="0.1s"
                    >
                        SOC 2/ISO 27001 Compliance
                    </h4>

                </div>

            </div>
            {/* Header End */}


            {/* SOC 2 CONTENT */}
            <section className="container py-5">

                <div className="row">

                    <div className="col-lg-12">

                        <h3>
                          SOC 2 & ISO 27001 Compliance Services
                        </h3>

                        <p>
                            Strengthen your security posture and achieve compliance with 
                            confidence. CelerSoft helps organizations prepare for SOC 2 Type I/II 
                            attestation and ISO 27001 certification through comprehensive readiness assessments, gap analysis, policy development, risk management, security control implementation, and audit support. Our experts identify compliance gaps, improve cybersecurity
                             controls, and provide a clear roadmap to meet regulatory and customer 
                             security requirements.
                        </p>
                        <ul>
                            <li>SOC 2 Readiness & Type I / Type II Support</li>
                            <li>ISO 27001 Readiness & Certification Preparation</li>
                            <li>Security Gap Assessments</li>
                            <li>Risk & Control Evaluations</li>
                            <li>ISMS Development & Governance</li>
                            <li>Audit Readiness & Evidence Collection</li>
                            <li>Remediation Planning & Compliance Advisory</li>
                        </ul>

                       
                    </div>

                </div>

            </section>

            <section className="soc-assessment-section py-5">

    <div className="container">

        <div className="soc-card">

            <div className="row align-items-center">

    {/* IMAGE - FIRST ON MOBILE */}
    <div className="col-lg-4 order-1 order-lg-2 text-center">

        <div className="soc-icon-wrapper">
            <i className="fas fa-shield-alt"></i>
        </div>

    </div>
    


    {/* CONTENT - SECOND ON MOBILE */}
    <div className="col-lg-8 order-2 order-lg-1">

        <span className="soc-badge">
         SECURITY ASSESSMENT
        </span>

        <h2>
            SOC 2 & ISO 27001 Readiness Assessment
        </h2>

        <p>
            Evaluate your organization’s security controls, compliance maturity, and audit readiness
             through CelerSoft’s online assessment. Receive a detailed 
            gap analysis and actionable recommendations to accelerate SOC 2 and ISO 27001 
            compliance.
        </p>

        {/* <div className="soc-features">

            <div>
                <i className="fas fa-check-circle"></i>
                5-Minute Assessment
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Instant Submission
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Expert Review
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Free Consultation
            </div>

        </div> */}

        <a
            href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=MUA-T_DqkEqb1rQhz5s6rXUclN3LD91Op1IOACnr1QNUQUUzV0UxUFpJQjZaT05HMTlER0Y0MFZKTy4u&route=shorturl"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-lg rounded-pill mt-4"
        >
            Start Assessment
            <i className="fas fa-arrow-right ms-2"></i>
        </a>

    </div>

</div>

        </div>

    </div>

</section>

{/* =========================================
    COMPLIANCE & READINESS ASSESSMENTS
========================================= */}

<section className="compliance-assessments py-5">

    <div className="container">

        {/* Section Heading */}
        <div
            className="text-center mx-auto mb-5"
            style={{ maxWidth: 800 }}
        >

            <h2 className="text-primary">
                COMPLIANCE & READINESS ASSESSMENTS
            </h2>

            <p className="mb-0">
                Know where you stand. Understand what comes next.
                Assess your organization's security and compliance readiness.
            </p>

        </div>


        {/* Assessment Panels */}
        <div className="row g-4 align-items-stretch">


            {/* =========================
                SOC 2
            ========================= */}

            <div className="col-lg-6">

                <div className="assessment-panel assessment-soc2">

                    <div className="assessment-visual">

                        <div className="assessment-icon">
                            <i className="fas fa-shield-alt"></i>
                        </div>

                    </div>


                    <div className="assessment-content">

                        {/* <span className="assessment-label">
                            SECURITY ASSESSMENT
                        </span> */}

                        <h3>
                            SOC 2 & ISO 27001
                        </h3>

                        <h4>
                            Readiness Assessment
                        </h4>

                        <p>
                            Evaluate your organization’s security controls, compliance maturity, and audit readiness through CelerSoft’s online assessment. Receive a 
                            detailed gap analysis and actionable recommendations to accelerate SOC 2 and ISO 27001 
                            compliance.
                        </p>


            


                        <a
                            href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=MUA-T_DqkEqb1rQhz5s6rXUclN3LD91Op1IOACnr1QNUQUUzV0UxUFpJQjZaT05HMTlER0Y0MFZKTy4u&route=shorturl"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="assessment-btn"
                        >
                            Start SOC 2 Assessment
                            <i className="fas fa-arrow-right ms-2"></i>
                        </a>

                    </div>

                </div>

            </div>


            {/* =========================
                CMMC
            ========================= */}

            <div className="col-lg-6">

                <div className="assessment-panel assessment-cmmc">

                    <div className="assessment-visual">

                        <div className="assessment-icon">
                            <i className="fas fa-lock"></i>
                        </div>

                    </div>


                    <div className="assessment-content">

                        {/* <span className="assessment-label">
                            DEFENSE & CYBERSECURITY
                        </span> */}

                        <h3>
                            CMMC
                        </h3>

                        <h4>
                            Readiness Assessment
                        </h4>

                        <p>
                            Assess your organization's cybersecurity
                            practices and understand your current readiness
                            for CMMC requirements.
                        </p>


                        


                        <a
                            href="https://forms.cloud.microsoft/r/uK94Nkji5c"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="assessment-btn"
                        >
                            Start CMMC Assessment
                            <i className="fas fa-arrow-right ms-2"></i>
                        </a>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>


            <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
                <div className="container pt-4">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
                            <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
                            <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
                            <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                                <hr />
                                <div className="d-flex align-items-center">
                                    <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                                        <i className="fab fa-facebook-f" />
                                    </a>
                                    <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                                        <i className="fab fa-linkedin-in" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid copyright py-3">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-6 text-center text-md-start mb-md-0">
                            <span className="text-body">
                                <i className="fas fa-copyright text-light me-1" />
                                2024 Celersoft. All rights reserved.
                            </span>
                        </div>
                        {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
                    </div>
                </div>
            </div>

            {/* <a href="/" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

            <button
                className="btn btn-primary btn-lg-square back-to-top"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
                <i className="fa fa-arrow-up" />
            </button>

        </>
    );
};

export default Soc2;